module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "content-c",
    attrs: {
      "id": "calibre_toc_2"
    }
  }, [_c('span', {
    staticClass: "bold5"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_005#b1"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_006#b2"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_007#b3"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_008#b4"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_008#b4"
    }
  }, [_vm._v("My Wish and Prayer That You Get Unstuck")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_009#b5"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_009#b5"
    }
  }, [_vm._v("The Root of the Rut ~ The Inside Out Approach to Healing")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_010#b6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_010#b6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Is Trauma Anyway? Trauma vs. Drama")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_011#b7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_011#b7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sexual Trauma ~ You Can Overcome Anything")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_012#b8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_012#b8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Facing Difficulties Head On ~ Confidence From Within")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a9"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_013#b9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Five")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_013#b9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unlucky in Love…Over and Over ~ Finally Free")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_014#b10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Six")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_014#b10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Work Place Challenges ~ We All Have Them…")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a11"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_015#b11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Seven")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_015#b11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Humor as a Healer ~ Bring Your “A” Game to the Tickle Challenge")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_016#b12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Eight")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_016#b12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Surviving or Thriving After the Loss of a Loved One? Good Grief")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_017#b13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Nine")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_017#b13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silence as a Healer ~ Shut Up Already!")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_018#b14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Ten")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_018#b14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compassion and Imagination to the Rescue ~ Tap Into Your Creativity")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_019#b15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Eleven")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_019#b15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epigenetics ~ Shifts in Potential")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_020#b16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Twelve")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_020#b16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Depression vs. the Blues ~ Knowing the Difference Can Save Your Life or the Life of Someone You Love")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_021#b17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Thirteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_021#b17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loving Relationships as a Recovery Tool ~ Turn to Your Tribe of Support")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_022#b18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Fourteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_022#b18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hormones and Wellness ~ The Rulers of Our Bodies We Didn’t Even Know About")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_023#b19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Fifteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_023#b19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Somatic Therapy ~ Body Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_024#b20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Sixteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_024#b20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Positive Psychology ~ Say Yes to Yourself")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_025#b21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Chapter Seventeen")])])]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_025#b21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gifts from My Elders ~ Being Open to Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_026#b22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a23"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_027#b23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a24"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_028#b24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "id": "a25"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_029#b25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("End Notes")])])]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f97e088","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/HappyHealthyYou_split_004.vue
// module id = 72
// module chunks = 0